const normalizarBaseUrl = (valor) => `${String(valor || "").replace(/\/+$/, "")}/`;

export const API_BASE_URL = normalizarBaseUrl(
  import.meta.env?.VITE_API_URL || "/api/"
);
